import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // 🔥 Firestore import karna zaroori hai
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAXtn9bW6k09u0OkokkEPVRMSWj5C6iLzU",
  authDomain: "whatsapp-autoreply-bot-pivot.firebaseapp.com",
  projectId: "whatsapp-autoreply-bot-pivot",
  storageBucket: "whatsapp-autoreply-bot-pivot.firebasestorage.app",
  messagingSenderId: "523088958829",
  appId: "1:523088958829:web:8b63b5bb10f4fc4da3b664"
};

// Initialize Firebase
// 🔥 NAYA CHANGE: Yahan export add kiya hai taaki SocialAutopilot isko use kar sake
export const app = initializeApp(firebaseConfig); 

// 🔥 In dono ko export karna zaroori hai taaki App.js inhein use kar sake
export const db = getFirestore(app); 
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();